import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import { NAVY } from '../../utils/constants';

interface ModuleCardProps {
  title: string;
  description: string;
  link: string;
  icon: LucideIcon;
  label: string;
  index?: number;
}

const ModuleCard = ({ title, description, link, icon: Icon, label, index = 0 }: ModuleCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08, duration: 0.4 }}
    >
      <Link
        to={link}
        className="block bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 h-full"
        style={{ borderColor: 'rgba(229,231,235,1)' }}
        onMouseEnter={e => (e.currentTarget.style.borderColor = `${NAVY}33`)}
        onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(229,231,235,1)')}
      >
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${NAVY}14` }}
          >
            <Icon className="w-5 h-5" style={{ color: NAVY }} />
          </div>
          <span
            className="text-xs font-semibold uppercase tracking-wider font-paragraph"
            style={{ color: `${NAVY}80` }}
          >
            {label}
          </span>
        </div>
        <h3 className="font-semibold text-base mb-1 font-heading" style={{ color: NAVY }}>
          {title}
        </h3>
        <p className="text-sm text-gray-500 leading-relaxed font-paragraph">
          {description}
        </p>
      </Link>
    </motion.div>
  );
};

export default ModuleCard;
